import { useEffect, useRef } from "react";
import { noop } from "lodash";
import type { CreateSubmissionPayload } from "@/react/api/submissionsApi";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Form } from "@circle-react-uikit/Form";
import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { useSubmitForm } from "../hooks/useSubmitForm";
import { usePunditUserContext } from "@/react/contexts";
import { t } from "@/i18n-js/instance";

export const FormWrapper = ({ children }: { children: React.ReactNode }) => {
  const {
    form,
    isPreview,
    isUsedOnPages,
    formStyles,
    formDomId,
    formBackgroundColor,
    isModal,
    setFormHeight,
    index,
    renderType,
  } = useFormRenderingContext();
  const { currentCommunity } = usePunditUserContext();
  const formRef = useRef<HTMLDivElement>(null);
  const { mutate } = useSubmitForm();

  const handleSubmit = (payload: CreateSubmissionPayload) => {
    const transformedPayload = {
      ...payload,
      elements: payload.elements.map(element => {
        if (Array.isArray(element.value)) {
          return {
            ...element,
            value_json: element.value,
          };
        }
        return element;
      }),
    };
    mutate(transformedPayload);
  };

  useEffect(() => {
    setFormHeight(formRef.current?.scrollHeight || 0);
  }, [setFormHeight]);

  return (
    <div
      className={classNames({
        "bg-secondary py-12 flex flex-col w-full items-center min-h-[100vh] h-fit gap-6":
          renderType === "standalone",
      })}
    >
      <div
        className={classNames({
          "rounded-lg p-10 shadow-lg border-primary border w-full max-w-[600px] h-fit":
            renderType === "standalone",
        })}
        style={{
          backgroundColor:
            renderType === "standalone" ? formBackgroundColor : undefined,
        }}
      >
        <div ref={formRef} id={`form-wrapper-${form.uid}-${index}`}>
          <Form
            id={formDomId}
            onSubmit={isPreview ? noop : handleSubmit}
            className={classNames("w-full px-1", {
              "max-w-[600px]": !isModal && !isUsedOnPages,
              "pb-6 pt-0": isModal,
            })}
            formClassName="mb-0"
            style={{
              backgroundColor: !isUsedOnPages ? formBackgroundColor : undefined,
            }}
          >
            <style>{formStyles}</style>
            {children}
          </Form>
        </div>
      </div>
      {renderType === "standalone" &&
        currentCommunity &&
        !currentCommunity.white_label && (
          <a href="https://circle.so" target="_blank" rel="noreferrer">
            <span className="text-light">{t("powered_by")} </span>
            <span className="text-dark font-semibold">{t("circle")}</span>
          </a>
        )}
    </div>
  );
};
